// extracted by mini-css-extract-plugin
export default {"card":"VoteDetailCard_card__rgR1J","cardSection":"VoteDetailCard_cardSection__42D0c","motion":"VoteDetailCard_motion__puc2c","title":"VoteDetailCard_title__6S9ht"};